module.exports = __webpack_public_path__ + "img/STERiJECT_02.ec59a06c.png";